<template>
  <LMarker
    ref="markerEl"
    :lat-lng="latLng"
    :draggable="draggable"
    :z-index-offset="zIndexOffset"
    @click="handleClick"
    @dragend="handleDragend"
  >
    <LTooltip v-if="tooltip" ref="tooltipEl" :content="tooltip" :options="computedTooltipOptions" @ready="handleTooltipReady" />
    <LIcon v-bind="icon" />
  </LMarker>
</template>

<script>
import { LMarker, LTooltip, LIcon } from 'vue2-leaflet'

export default {
  name: 'MapMarker',
  components: {
    LMarker,
    LTooltip,
    LIcon
  },
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    latLng: {
      type: Object,
      required: true
    },
    icon: {
      type: Object,
      required: true
    },
    draggable: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    tooltipOptions: {
      type: Object,
      default: () => ({})
    },
    permanentTooltip: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedTooltipOptions() {
      return {
        ...this.tooltipOptions,
        direction: 'bottom',
        permanent: this.permanentTooltip
      }
    },
    zIndexOffset() {
      return this.icon.id > 100 ? -100 : 1000
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', this.id)
    },
    handleDragend(e) {
      const { lat, lng } = e.target.getLatLng()
      this.$emit('dragend', { id: this.id, lat, lng })
    },
    handleTooltipReady() {
      this.refreshTooltip()
    },
    async refreshTooltip() {
      await this.$nextTick()
      const mapObject = this.$refs.tooltipEl?.parentContainer?.mapObject
      if (!mapObject) return
      mapObject.unbindTooltip()
      mapObject.bindTooltip(this.tooltip, this.computedTooltipOptions)
    }
  },
  watch: {
    'computedTooltipOptions.permanent': {
      immediate: true,
      handler() {
        this.refreshTooltip()
      }
    },
    tooltip() {
      this.refreshTooltip()
    }
  }
}
</script>
<style lang="scss">
.floor-map_print {
  .leaflet-tooltip {
    color: blue !important;
    text-align: center;
    font-size: 12px;
    line-height: 10px !important;
    margin-top: 4px !important;

    box-shadow: none !important;
    padding: 0 !important;
    background-color: transparent !important;
    border: none !important;
    filter: drop-shadow(1px 0 0 #fff) drop-shadow(-1px 0 0 #fff) drop-shadow(0 -1px 0 #fff) drop-shadow(0 1px 0 #fff) !important;
    opacity: 1 !important;

    &:before {
      display: none;
    }
  }

  .tooltip__first_only {
    font-weight: normal;
    & > * {
      display: block;
    }
  }

  .tooltip__second {
    margin-top: 4px;
    display: block;
  }
}

.leaflet-tooltip {
  .tooltip__first {
    font-weight: bold;
    display: inline-block;
    width: max-content;
    max-width: 200px;
    white-space: normal;
    word-wrap: break-word;
  }

  .tooltip__first_only {
    font-weight: normal;
    & > * {
      display: block;
    }
  }

  .tooltip__second {
    display: block;
  }
}
.fpm-marker {
  filter: drop-shadow(0px 0px 1px #00000070);

  &_active {
    // prettier-ignore
    filter:
      brightness(60%)
      contrast(179%)
      hue-rotate(183deg)
      invert(100%)
      saturate(272%)
      drop-shadow(0.8px 0 0.7px rgba(0, 0, 0, 0.8))
      drop-shadow(1.2px 0.8px 0.8px rgba(0, 0, 0, 0.7))
      drop-shadow(1.4px -1.2px 1.2px rgba(0, 0, 0, 0.6))
      drop-shadow(1.8px -1.6px 1.6px rgba(0, 0, 0, 0.5))
      drop-shadow(2.2px -2px 2px rgba(255, 255, 255, 0.4))
      drop-shadow(2.6px -2.6px 3px rgba(255, 255, 255, 0.3))
  }
}
</style>
